import { Handle, type NodeProps } from "@xyflow/react";
import type { UnaryNodeData } from "@/types/decision-graph";
import { getHandlePositions } from "../utils/handle-positions";

export function UnaryNode({ data }: NodeProps) {
  const d = data as UnaryNodeData;
  const { inputPosition, outputPosition } = getHandlePositions(d.layoutDirection);

  return (
    <div className="rounded-md border border-rose-300 bg-rose-50 px-3 py-2 text-xs shadow-sm min-w-[70px]">
      <Handle type="target" position={inputPosition} id="operand" />
      <div className="font-medium text-rose-700 text-[10px] mb-0.5">
        {d.operator}
      </div>
      <div className="text-rose-900 font-mono text-center text-sm font-bold">
        {d.label}
      </div>
      <Handle type="source" position={outputPosition} id="result" />
    </div>
  );
}
